import React, { useMemo } from "react";
import { formatMoney } from "../../../../../features/utils/formatMoney";

function PricingSectionRejected({ data }) {
  return (
    <div className="w-full border h-fit border-gray-200 rounded-xl overflow-hidden bg-white mt-4 p-4">
      {/* Header */}
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-bold text-gray-900">Refund</h2>
      </div>

      {/* Content */}
      <div className="bg-red-100 border border-red-400 px-4 w-fit rounded-md h-8 flex items-center justify-center text-red-600 text-sm">
        Refund request failed
      </div>
      {data?.rejectReason ? (
        <div className="w-full flex flex-col gap-1 mt-4">
          <span className="font-bold text-sm">Reason</span>
          <span className="text-sm">{data?.rejectReason}</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  );
}

export default PricingSectionRejected;
